<template>
  <div class="expand-all-controls-wrapper">
    <label class="expand-label">
      Indicators
    </label>
    <button @click="openCloseAll('showCurrentIndicators', true)" class="btn btn-primary first">Show All</button>
    <button @click="openCloseAll('showCurrentIndicators', false)" class="btn btn-primary">Hide All</button>
  </div>
</template>

<script>
import { openCloseAll } from '../helpers/openCloseHelpers';

export default {
  name: 'open-hide-all-controls',
  props: ['categories'],
  data() {
    return {
      viewProperties: {
        'long-term-map': 'ShowHistoricalIndicators',
        'comparison-view': 'showCurrentIndicators',
      },
    };
  },
  methods: {
    openCloseAll,
  },
  computed: {
    viewProperty() {
      return this.viewProperties[this.$route.name];
    },
  },
};
</script>

<style lang="less">
  .expand-all-controls-wrapper {
    margin-left: 20px;
    display: flex;
    flex-basis: auto;
    justify-content: space-around;
    button {
      margin: 5px 3px 0 3px;
      height: 25px;
      padding-top: 2px;
      background-color: #265EAC;
      border-radius: 2px;
    }

    @media(max-width: 1200px) {
      justify-content: flex-start;
      margin-bottom: 3px;
    }
  }

  .current-wrapper {
    .expand-all-controls-wrapper {
      @media (max-width: 500px) {
        margin-left: 0;
        margin-top: 10px;
      }
    }
  }

  .map-controls-wrapper {
    .expand-all-controls-wrapper {
      margin-left: 0;
      flex-wrap: wrap;
      justify-content: flex-start;
      button {
       flex-grow: 0; 
        &.first {
          margin: 5px 3px 0 0;
        } 
      }
    }
    .expand-label {
      flex: 1 0 100%;
      margin-right: 0;
    }
  }
  .expand-label {
    padding-top: 6px;
    font-size: 16px;
    margin-right: 6px;
  }
</style>



// WEBPACK FOOTER //
// OpenCloseAll.vue?0e3b5396